import { Button } from "@tremor/react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

export const TitlePageInfo = ({ title }) => {
  const navigate = useNavigate();

  const goBack = () => navigate(-1);

  return (
    <>
      <div className="flex justify-between items-center my-3">
        <h1 className="text-3xl">{title}</h1>
        <Button variant="secondary" onClick={goBack}>
          Regresar
        </Button>
      </div>
    </>
  );
};

TitlePageInfo.propTypes = {
  title: PropTypes.string,
};
